import React from 'react';
import Popover from 'pcln-popover';
import { Flex, IconButton, Text } from 'pcln-design-system';
import { Close, InformationOutline } from 'pcln-icons';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
const MontserratText = /*#__PURE__*/styled(Text.p).withConfig({
  displayName: "FooterHint__MontserratText",
  componentId: "sc-1asmbyf-0"
})(["&&&{font-family:'Montserrat','Helvetica Neue',Helvetica,Arial,sans-serif;}"]);
const AbsolutePosBtn = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "FooterHint__AbsolutePosBtn",
  componentId: "sc-1asmbyf-1"
})(["&&&{top:20px;right:20px;position:absolute;}"]);
const InfoButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "FooterHint__InfoButton",
  componentId: "sc-1asmbyf-2"
})(["&&&{background-color:transparent;color:inherit;padding:0;}"]);
// z-index should be > that of <Footer />
const Z_INDEX = 2000;
function FooterHintContent({
  handleClose
}) {
  function stopPropagation(e) {
    e.stopPropagation();
  }
  return React.createElement(FocusLock, null, React.createElement(Flex, {
    "data-testid": 'footer-hint-content',
    flexDirection: 'column',
    p: 2,
    onClick: stopPropagation
  }, React.createElement(MontserratText, {
    fontSize: 1,
    mb: 1,
    mt: 0,
    fontWeight: 'bold'
  }, "Tip:"), React.createElement(MontserratText, {
    mt: 0,
    mb: 1
  }, "Use arrow keys to navigate the calendar"), React.createElement(AbsolutePosBtn, {
    onClick: handleClose,
    title: 'Close tooltip',
    icon: React.createElement(Close, null)
  })));
}
/** @public */
function FooterHint() {
  return React.createElement(Popover, {
    renderContent: FooterHintContent,
    placement: 'top',
    ariaLabel: 'Calendar navigation tooltip',
    overlayOpacity: 0.3,
    width: 350,
    borderColor: 'borderGray',
    zIndex: Z_INDEX,
    idx: 'date-picker-footer'
  }, React.createElement(InfoButton, {
    icon: React.createElement(InformationOutline, {
      color: 'text.base',
      size: 20
    }),
    title: 'Navigation tip',
    type: 'button'
  }));
}
export default FooterHint;